<template>
  <div class="home-page">
    <grid-layout
      v-if="layout.length"
      :layout.sync="layout"
      :col-num="defaultParams.colNum"
      :row-height="defaultParams.rowHeight"
      :is-draggable="defaultParams.isDraggable"
      :is-resizable="defaultParams.isResizable"
      :vertical-compact="false"
      :margin="defaultParams.margin"
      :use-css-transforms="true"
      ref="gridlayout"
      style="touch-action: none;"
      :preventCollision="true"
    >
      <grid-item
        v-for="(item, index) in layout"
        :key="index"
        :x="item.x"
        :y="item.y"
        :w="item.w"
        :h="item.h"
        :i="item.i"
        :class="{
          'z-10': item.component === 'BayWindow' || item.component === 'NavigationBar',
        }"
      >
        <div class="grid-item h-full">
          <component :is="item.component" :data="item.data" mode="view"></component>
        </div>
      </grid-item>
    </grid-layout>
  </div>
</template>

<script>
import VueGridLayout from 'vue-grid-layout'
import { ColumApi, ColumnPageApi } from '@wiz-api/workbench-std'
import exportComponent from '../js/exportComponents'

const columnApi = new ColumApi()
const columnPageApi = new ColumnPageApi()
export default {
  name: 'homepage',
  components: {
    ...exportComponent,
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem,
  },
  data() {
    return {
      defaultParams: {
        rowHeight: 1,
        colNum: window.innerWidth,
        isDraggable: false,
        isResizable: false,
        margin: [0, 0],
      }, // layout配置
      layout: [],
      layoutConifg: {},
    }
  },
  computed: {
    columnId() {
      return this.$route.query.columnId
    },
    routerBase() {
      if (window.__POWERED_BY_QIANKUN__) {
        return `/${_.get(Wiz, 'globalSettings.globalConfig.routerBase')}`
      }
      return ''
    },
  },
  watch: {
    columnId: {
      immediate: true,
      async handler(val) {
        // 获取首页栏目
        if (!this.columnId) {
          const [err, res] = await columnApi.getHomeColumnDetail()
          if (!err) {
            this.$router.replace({
              path: `${this.routerBase}/integration/portal/homepage`,
              query: {
                columnId: res.id,
              },
            })
          }
          return
        }
        if (val) {
          this.getLayoutConfig()
          this.getColumnDetail()
        }
      },
    },
  },
  methods: {
    async getLayoutConfig() {
      this.layout = []
      this.defaultLayout = []
      const [err, res] = await columnPageApi.getColumnPage(1, 1, {
        columnId: this.columnId,
        isActive: true,
        type: 0,
      })
      if (!err && res.items.length && res.items[0].pageDesign) {
        this.defaultLayout = res.items[0]
        this.layout = this.getResizeLayout()
      }
    },
    getResizeLayout() {
      if (_.isEmpty(this.defaultLayout)) return []
      return _.map(JSON.parse(this.defaultLayout.pageDesign), (item) => {
        if (this.defaultLayout.windowWidth > window.innerWidth) {
          item.x = _.ceil(item.x - (this.defaultLayout.windowWidth - window.innerWidth) / 2)
        } else {
          item.x = _.ceil((window.innerWidth - this.defaultLayout.windowWidth) / 2 + item.x)
        }
        return item
      })
    },
    async getColumnDetail() {
      const [err, res] = await columnApi.getColumnDetail(this.columnId)
      if (!err) {
        const { config } = Wiz.globalSettings.dynamicModules.modules['portal-homepage-std']
        document.title = `${res.name} - ${config?.title}`
      }
    },
  },
  async created() {},
  mounted() {
    window.onresize = () => {
      this.defaultParams.colNum = window.innerWidth
      this.layout = this.getResizeLayout()
    }
  },
}
</script>

<style lang="scss" scoped>
.home-page {
  .vue-grid-item {
    transition: none;
  }
}
</style>
